var _path, _path2, _path3, _path4, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2605(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 685,
    height: 754,
    viewBox: "0 0 685 754",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M341.796 432.854L227.4 324.184V215.929L341.796 324.301L570.299 107.768V216.14L341.796 432.854Z",
    fill: "#4569FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.796 432.856L227.4 324.187V215.931L341.796 324.304V432.856Z",
    fill: "#4569FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M343.84 216.446V108.312L458.595 0V108.312L343.84 216.446Z",
    fill: "#4569FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M114.05 753.037L0 645.563V538.499L114.05 645.679L341.862 431.527V538.707L114.05 753.037Z",
    fill: "#4569FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.9 540.367V432.233L227.655 323.921V432.233L112.9 540.367Z",
    fill: "#4569FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.196 752.834L341.8 645.361V538.297L456.196 645.477L684.699 431.325V538.505L456.196 752.834Z",
    fill: "#4569FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.583 538.164V430.031L572.687 321.719V430.031L457.583 538.164Z",
    fill: "#4569FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2605);
export default __webpack_public_path__ + "static/media/Group 2605.c646387ab196f1a385afc47a94a08542.svg";
export { ForwardRef as ReactComponent };